import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SITE_URL, SUPPORT_EMAIL } from '../data/launch';
export function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-651" data-mp="2amizminws68d">
      <SEO title="Terms of Use | KittyPot" description="The terms for using the KittyPot app and website. KittyPot helps groups track shared expenses and settle up directly; it does not hold or move money." ogTitle="KittyPot Terms of Use" ogDescription="The terms for using the KittyPot app and website." path="/terms" data-id="element-652" data-mp="20q5vsryngbzw" />
      <Navbar data-id="element-653" data-mp="3q4ayu0vnodvi" />
      <main className="pt-32 pb-24" data-id="element-654" data-mp="3q2rjqdlqk8vb">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-655" data-mp="3m38ythtwzxsh">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-656" data-mp="3m1o5twn90mwq">
            Terms of Use
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-657" data-mp="2u3nx1quzawp3">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-658" data-mp="2g4eggq2v20kl">
            <p data-id="element-659" data-mp="2k5hvxbgzxula">
              These terms apply when you use the KittyPot app or {SITE_URL} (the
              “Service”), provided by {COMPANY.legalName} (company number{' '}
              {COMPANY.registrationNumber}), referred to as “KittyPot”, “we” or
              “us”. By using the Service you agree to these terms.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-660" data-mp="2z1pg4bsemw0k">
              1. What KittyPot does
            </h2>
            <p data-id="element-661" data-mp="332j3n41xq8sx">
              KittyPot helps groups record shared expenses, split costs between
              members, and keep track of who owes what. It is a record-keeping
              tool.
            </p>
            <p data-id="element-662" data-mp="3vmrezww7qkm2">
              KittyPot does not hold your money, does not act as a wallet, and
              does not transfer funds between members. Any payment between you
              and another member happens directly between you, outside KittyPot.
              We are not a party to it and cannot guarantee that anyone will
              pay.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-663" data-mp="3rg2om81lzhjp">
              2. Your account
            </h2>
            <p data-id="element-664" data-mp="3mj2hruwxqarj">
              You need an account to use the full app. You must give accurate
              details, keep your sign-in secure, and let us know if you think
              someone else has access to your account. You are responsible for
              activity carried out under your account.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-665" data-mp="33r9zaufhs7y2">
              3. Acceptable use
            </h2>
            <p data-id="element-666" data-mp="2yroq7r6lyj7m">When using KittyPot, you agree not to:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-667" data-mp="2yu9rof2zux4u">
              <li data-id="element-668" data-mp="2on896uhe6w28">use the Service for anything unlawful or fraudulent</li>
              <li data-id="element-669" data-mp="2tn3213kq9vpx">
                add someone to a kitty, or upload information about them,
                without a good reason to do so
              </li>
              <li data-id="element-670" data-mp="2yn7gko22sgdi">
                harass other members, or use expense descriptions and
                notifications to send abusive content
              </li>
              <li data-id="element-671" data-mp="25yjuwrdezozf">
                attempt to disrupt the Service, access it without authorisation,
                or interfere with other people's data
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-672" data-mp="2fvesn81v5lcn">
              4. Creating and joining kitties
            </h2>
            <p data-id="element-673" data-mp="2ko7wzutf6ro7">
              You can create a kitty and invite others by link, code, QR or from
              your contacts, and people can take part from the app or from their
              browser. Members of a kitty can see that kitty's expenses,
              balances and settlement records. Only add people who should see
              that information.
            </p>
            <p data-id="element-674" data-mp="3oxho533vo6l2">
              A kitty may have one or more admins who can manage members, rename
              the kitty and close it. Admin roles are held by members using the
              app so that a kitty always has someone able to manage it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-675" data-mp="ggd48pk0jpdf">
              5. Expenses, balances and accuracy
            </h2>
            <p data-id="element-676" data-mp="ce9sdztfmirm">
              Everything KittyPot shows is calculated from information that you
              and other members enter. We do not verify amounts, and we cannot
              confirm that an expense really happened or that a split is fair.
              It is your responsibility to check that the amounts, payers and
              splits are right.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-677" data-mp="2n7w69ab0sbyy">
              6. Receipts
            </h2>
            <p data-id="element-678" data-mp="12qd5fqu42n5l">
              You can attach a receipt image to an expense. Where the app reads
              details from a receipt automatically, those details are a
              suggestion and may be wrong or incomplete. Always check them
              before saving. Only upload receipts you are entitled to share with
              the group.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-679" data-mp="jy17dgahq819">
              7. Settling up
            </h2>
            <p data-id="element-680" data-mp="oyotbnjv3yom">
              Settlement in KittyPot is a record, not a payment. When you mark
              an amount as paid, you are telling the group that you have paid it
              elsewhere, and the person receiving it can confirm they got it.
              Disputes about whether a payment was actually made are between the
              members concerned.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-681" data-mp="29dqufkw6qagh">
              8. Currencies
            </h2>
            <p data-id="element-682" data-mp="27x4nyw06xpz6">
              Where a kitty involves more than one currency, converted amounts
              shown in the app are for presentation only. They may not match the
              rate your bank or payment provider uses at the time you settle.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-683" data-mp="1tx279d3md2li">
              9. Sharing bank details
            </h2>
            <p data-id="element-684" data-mp="2qli13ldrhy4f">
              You may choose to save bank details so they are easy to share when
              your group settles up. This is optional, and you decide when to
              share them. KittyPot does not use them to make payments. Please
              take the same care you would take anywhere else when sharing
              account details.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-685" data-mp="39dkjb161xmgs">
              10. Your content
            </h2>
            <p data-id="element-686" data-mp="34lstisupzkrp">
              You keep ownership of the content you add, such as expense
              descriptions and receipt images. You give us permission to store
              and process that content, and to show it to the other members of
              the relevant kitty, so that we can provide the Service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-687" data-mp="106z9ih2vg944">
              11. Our intellectual property
            </h2>
            <p data-id="element-688" data-mp="1a3byx2rdw0t2">
              The KittyPot name, logo, app and website, including their design
              and software, belong to {COMPANY.legalName}. You may use them only
              as part of using the Service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-689" data-mp="1jt5cg9b36pzy">
              12. Availability and changes
            </h2>
            <p data-id="element-690" data-mp="1stbnlojbbdvy">
              We work to keep KittyPot available and running well, but we cannot
              promise it will be available without interruption. We may update,
              change or withdraw features, and we will give reasonable notice of
              significant changes where we can.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-691" data-mp="13qo4ph8jre9o">
              13. Suspension and ending your account
            </h2>
            <p data-id="element-692" data-mp="1hp4l5zw7oj50">
              You can delete your account at any time, see{' '}
              <Link to="/delete-account" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-693" data-mp="1dpndr0x85bx7">
                Delete your KittyPot account
              </Link>
              . We may suspend or end access if these terms are seriously or
              repeatedly broken, or where we are required to by law. We will
              tell you why unless we are prevented from doing so.
            </p>
            <p data-id="element-694" data-mp="69pf86m0ygxr">
              When an account is deleted, we remove or anonymise the account
              information described in our{' '}
              <Link to="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-695" data-mp="272t8mc1bq8h">
                Privacy Policy
              </Link>
              . Limited shared kitty history may be kept in anonymised form so
              other members' records stay accurate.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-696" data-mp="3jbt6iwsqf4cj">
              14. Our responsibility to you
            </h2>
            <p data-id="element-697" data-mp="fujf2r8ajks2">
              We provide KittyPot with reasonable care and skill. We are
              responsible for loss you suffer that is a foreseeable result of us
              breaking these terms or failing to use reasonable care and skill.
            </p>
            <p data-id="element-698" data-mp="5usm4tzdpdu3">
              We are not responsible for loss that is not foreseeable, for money
              another member fails to pay you, or for decisions you make based
              on figures entered by members. Nothing in these terms limits our
              liability for death or personal injury caused by our negligence,
              for fraud, or for anything else that cannot be limited by law.
              Nothing in these terms affects your legal rights as a consumer.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-699" data-mp="1e88rd57x3pxq">
              15. Changes to these terms
            </h2>
            <p data-id="element-700" data-mp="1593ue3c084no">
              We may update these terms as the Service develops. If a change
              materially affects you, we will give reasonable notice. Continuing
              to use KittyPot after a change means you accept the updated terms.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-701" data-mp="vdtqtb5yjp7s">
              16. Governing law
            </h2>
            <p data-id="element-702" data-mp="2ppqequ56ycy3">
              These terms are governed by the law of England and Wales, and the
              courts of England and Wales have jurisdiction. If you live
              elsewhere in the UK, you may bring proceedings in your local
              courts.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-703" data-mp="e2510p1sz9zy">
              17. Contact us
            </h2>
            <p data-id="element-704" data-mp="srjcc2oxw1hz">
              Questions about these terms? Email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-705" data-mp="ssugi3marb9m">
                {SUPPORT_EMAIL}
              </a>{' '}
              or write to us:
            </p>
            <address className="not-italic" data-id="element-706" data-mp="xsgpu1z087d5">
              {COMPANY.addressLines.map(line => <React.Fragment key={line} data-id="element-707" data-mp="1bnj4peltx723">
                  {line}
                  <br data-id="element-708" data-mp="16rbwtg9vhlhi" />
                </React.Fragment>)}
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-709" data-mp="38i5huj2mquww" />
    </div>;
}